import { Badge } from "@/components/ui/badge";

type Environment = "local" | "staging" | "production";

function getEnvironment(): Environment {
  if (typeof window === "undefined") return "local";
  
  const hostname = window.location.hostname;
  
  if (hostname === "admin.production.saturn.engineering") {
    return "production";
  } else if (hostname === "admin.staging.saturn.engineering") {
    return "staging";
  } else {
    return "local";
  }
}

const ENV_STYLES: Record<Environment, string> = {
  local: "bg-blue-500/10 text-blue-500 hover:bg-blue-500/20 border-blue-500/20",
  staging: "bg-yellow-500/10 text-yellow-500 hover:bg-yellow-500/20 border-yellow-500/20",
  production: "bg-green-500/10 text-green-500 hover:bg-green-500/20 border-green-500/20",
};

const ENV_LABELS: Record<Environment, string> = {
  local: "Local",
  staging: "Staging",
  production: "Production",
};

export function EnvironmentPill() {
  const env = getEnvironment();
  
  // Don't show pill in production to keep UI clean
  if (env === "production") {
    return null;
  }
  
  return (
    <Badge 
      variant="outline" 
      className={`${ENV_STYLES[env]} font-medium text-xs px-2.5 py-0.5`}
    >
      {ENV_LABELS[env]}
    </Badge>
  );
}

